'use strict';

DoohApps
    .factory('DialogHandler', ['Notification', function (Notification) {
        return {
            AddMessage: function (message, replace) {
                Notification.info({ message: message, delay: 10000, replaceMessage: replace == true ? true : false });
            },
            AddError: function (error, replace) {
                Notification.error({ message: error, delay: 10000, replaceMessage: replace == true ? true : false });
                void 0;
            },
            AddLongMessage: function (message) {
                Notification.info({ message: message, delay: 9999999 });
            }
        }
    }]);